<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/sheet-event' }">
        <app-i18n code="entities.sheetEvent.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.sheetEvent.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.sheetEvent.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-sheet-event-view-toolbar v-if="record"></app-sheet-event-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-text :label="fields.type.label" :value="presenter(record, 'type')"></app-view-item-text>

        <app-view-item-text :label="fields.subtypeGame.label" :value="presenter(record, 'subtypeGame')"></app-view-item-text>

        <app-view-item-text :label="fields.subtypeGoal.label" :value="presenter(record, 'subtypeGoal')"></app-view-item-text>

        <app-view-item-text :label="fields.subtypeCard.label" :value="presenter(record, 'subtypeCard')"></app-view-item-text>

        <app-view-item-text :label="fields.subtypePenaltyShootout.label" :value="presenter(record, 'subtypePenaltyShootout')"></app-view-item-text>

        <app-view-item-relation-to-one
          :label="fields.teamId.label"
          :permission="fields.teamId.readPermission"
          :url="fields.teamId.viewUrl"
          :value="presenter(record, 'teamId')"
        ></app-view-item-relation-to-one>

        <app-view-item-text :label="fields.minute.label" :value="presenter(record, 'minute')"></app-view-item-text>

        <app-view-item-relation-to-one
          :label="fields.player.label"
          :permission="fields.player.readPermission"
          :url="fields.player.viewUrl"
          :value="presenter(record, 'player')"
        ></app-view-item-relation-to-one>

        <app-view-item-relation-to-one
          :label="fields.otherTeamId.label"
          :permission="fields.otherTeamId.readPermission"
          :url="fields.otherTeamId.viewUrl"
          :value="presenter(record, 'otherTeamId')"
        ></app-view-item-relation-to-one>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SheetEventViewToolbar from '@modules/sheet-event/components/sheet-event-view-toolbar.vue';
import { SheetEventModel } from '@modules/sheet-event/sheet-event-model';

const { fields } = SheetEventModel;

export default {
  name: 'app-sheet-event-view-page',

  props: ['id'],

  components: {
    [SheetEventViewToolbar.name]: SheetEventViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'sheetEvent/view/record',
      loading: 'sheetEvent/view/loading',
    }),

    fields() {
      return fields;
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'sheetEvent/view/doFind',
    }),

    presenter(record, fieldName) {
      return SheetEventModel.presenter(record, fieldName);
    },
  },
};
</script>
